exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".addcompany-modal{\n\t/*width:80%;\n\tpadding:2px;\n\tz-index: 10501;*/\n\theight: 83% !important;\n\t/* width: 85%; */\n}\ntextarea.company_address {\n    width: 105%;\n\tresize: none;\n}\nh6{\n\tfont-weight: bold;\n\tcolor: #007b85;\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/company/company.component.css
// module id = 453
// module chunks = 1